import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Pause = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <rect
          x='6'
          y='4'
          width='4'
          height='16'
          rx='1'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <rect
          x='14'
          y='4'
          width='4'
          height='16'
          rx='1'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <rect x='6' y='4' width='4' height='16' rx='1' fill='currentColor' />
        <rect x='14' y='4' width='4' height='16' rx='1' fill='currentColor' />
      </>
    )}
  </IconBase>
);
